import {
  createAsyncThunk,
  createSlice,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import { httpGet } from '@/utils/helpers/httpHelper';
import { AppState } from '@/store/store';
import CONFIG from 'config';

export type ImageType = {
  createdAt: string;
  endDate: string;
  imagePath: string;
  order: number;
  partnerName: string;
  startDate: string;
  targetUrl: string;
  title: string;
  type: string;
};

export const fetchBanners: any = createAsyncThunk(
  'banners/fetchBanners',
  async () => {
    const { data } = await httpGet(`${CONFIG.ENDPOINTS.banners}type/login/`);
    return data;
  }
);

const bannerAdapter = createEntityAdapter<ImageType>({
  selectId: (banner) => banner.createdAt,
});

export const bannerSlice = createSlice({
  name: 'banners',
  initialState: bannerAdapter.getInitialState({
    loading: true,
    error: false,
    banners: null as any,
  }),
  reducers: {},
  extraReducers: {
    [fetchBanners.pending](state) {
      state.loading = true;
    },
    [fetchBanners.fulfilled](state, { payload }) {
      state.banners = payload.data;
      state.loading = false;
    },
    [fetchBanners.rejected](state) {
      state.loading = false;
      state.error = true;
    },
  },
});

// export const {
//   changePage,

// } = campaignSlice.actions;
export const bannerSelectors = bannerAdapter.getSelectors<AppState>(
  (state) => state.banner
);
bannerAdapter.getSelectors<AppState>((state) => state.banner);

// export const { selectAll, selectById, selectIds, selectEntities } = companySelectors;

export default bannerSlice.reducer;
